import React from 'react'

const RequestMissingData = () => {
  return (
    <div>RequestMissingData</div>
  )
}

export default RequestMissingData